export const PoemExpectations = () => {
    return (
        <div id="048" className="Basic-Text-Frame">
            <p>caps lock reasoning,</p>
            <p>video will continue after this economic crisis ends,</p>
            <p>i doubt there are any easy answers -</p>
            <p>i used to want to be part of the world,</p>
            <p>but then the crowd fell over me and shattered my ribcage,</p>
            <p>i used to think i would find it inwards</p>
            <p>until that slowly became another outside in itself.</p>
            <p>so much of living is just</p>
            <p>saying "yes" to things you want to say "fuck off" to,</p>
            <p>including your own person,</p>
            <p>yes, do belittle me,</p>
            <p>the deeper i dig, the smaller i feel,</p>
            <p>halfway between</p>
            <p>a dog on a chain and an html button with my name on it,</p>
            <p>that's where everything happens.</p>
            <p>too warm with it on,</p>
            <p>too cold without it,</p>
            <p>that's how the drudge happens,</p>
            <p>i climbed up to the top of the mountain,</p>
            <p>hoping for a vision of God. maybe that was asking too much,</p>
            <p>a man in the cold surrounded by equally confused strangers.</p>
            <p>
                we make out in the sand the things we think we're supposed to
                see,
            </p>
            <p>and some of us see only</p>
            <p>grains of sand,</p>
            <p>i fell asleep in the grass</p>
            <p>and woke up full of bug bites,</p>
            <p>i'd call it natural order</p>
            <p>
                but it's just things doing what they think they're supposed to
                do,
            </p>
            <p>what do you do when meaning constantly eludes you,</p>
            <p>what do you turn into rituals,</p>
            <p>i live to live another day, the sun repeats the cycle,</p>
            <p>i live to live another day,</p>
            <p>where did i drop it?</p>
            <p>the taste, the feel, the smell,</p>
            <p>
                i stopped on the side of the road and blunted all the sharp
                things that i had on me,
            </p>
            <p>and now every time i come across prey</p>
            <p>i only have my teeth to stab it with.</p>
        </div>
    );
};
